import { useQuery } from '@tanstack/react-query'
import { getData } from '../../../apis/api.helpers'
import apiUrl from '../../../apis/api.url'
import { QueryParams } from '../../../common/types'
import { parseQueryParams } from '../../../utilities/parsers'

const buildUrlWithParams = (baseUrl: string, params: QueryParams) => {
  return `${baseUrl}${parseQueryParams(params)}`
}

const fetchFacilitationist = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.FACILITATION_LIST, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useFetchFacilitationist = (input: QueryParams) => {
  return useQuery(
    ['admin_user_list', input],
    () => fetchFacilitationist(input),
    {}
  )
}
const facilitationDetails = async (id: string) => {
  const url = `${apiUrl.FACILITATION_DETAIL}/${id}`
  const response = await getData(url)
  return response
}
export const useFacilitationDetails = (id: string) => {
  return useQuery(['worker_task', id], () => facilitationDetails(id), {
    refetchOnWindowFocus: false,
  })
}
